var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletConnectNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91462 3.52137C8.82902 -0.309208 15.1737 -0.309208 19.0881 3.52137L19.5585 3.98364C19.7531 4.17558 19.7531 4.48646 19.5585 4.67839L17.9473 6.25442C17.85 6.34904 17.6905 6.34904 17.5932 6.25442L16.9444 5.61914C14.214 2.94828 9.78599 2.94828 7.05564 5.61914L6.36089 6.29767C6.26357 6.39229 6.10408 6.39229 6.00676 6.29767L4.39559 4.72164C4.20095 4.52971 4.20095 4.21883 4.39559 4.02689L4.91192 3.52137H4.91462ZM22.4213 6.78157L23.854 8.18459C24.0487 8.37652 24.0487 8.6874 23.854 8.87934L17.3877 15.2078C17.1931 15.3997 16.8741 15.3997 16.6794 15.2078L12.0892 10.7176C12.0406 10.6689 11.9622 10.6689 11.9108 10.7176L7.32057 15.2078C7.12593 15.3997 6.80694 15.3997 6.6123 15.2078L0.145979 8.87934C-0.0486596 8.6874 -0.0486596 8.37652 0.145979 8.18459L1.57873 6.78157C1.77337 6.58963 2.09236 6.58963 2.287 6.78157L6.87723 11.2718C6.92588 11.3204 7.00428 11.3204 7.05564 11.2718L11.6459 6.78157C11.8405 6.58963 12.1595 6.58963 12.3541 6.78157L16.9444 11.2745C16.993 11.3231 17.0714 11.3231 17.1228 11.2745L21.713 6.78427C21.9076 6.59234 22.2266 6.59234 22.4213 6.78427V6.78157Z",
    fill: "#5570FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectNew);
export default __webpack_public_path__ + "static/media/walletConnectNew.fcac75d48fe0e89ad03d281f420e0a5c.svg";
export { ForwardRef as ReactComponent };